import { Button, Col, List, Row, Select, Tabs } from 'antd';
import { toJS } from 'mobx';
import { inject, observer } from 'mobx-react';
import React from 'react';
import { withRouter, RouteComponentProps } from 'react-router';
import styled from 'styled-components';

import { Importancia, Notification } from '../../models';
import { NotificationStore, UserStore } from '../../stores';

import { NotificationCard } from '../AppHeader/NotificationCard';
import { NotificationModal } from '../AppHeader/NotificationModal';

interface NotificacionesProps extends RouteComponentProps {
    notificationStore?: NotificationStore;
    userStore?: UserStore;
}

const Container = styled.div`
    margin: 40px;
    .ant-tabs-tab-active{
        color:#000 !important; 
    }
    .ant-tabs-ink-bar{
        background-color:#a8123e !important;
    }
`;


@inject('userStore')
@inject('notificationStore')
@inject('userStore')
@observer
class NotificacionesInner extends React.Component<NotificacionesProps, {}> {
    async componentDidMount() {
        const { notificationStore, userStore } = this.props;
        const fecha = new Date();
        notificationStore!.ejercicio = fecha.getFullYear();
        await notificationStore!.getNotifications(userStore!.rol);
        await notificationStore!.getMunicipios();
        await notificationStore!.getOrganismos();
    }

    onClick = () => {
        const { notificationStore } = this.props;
        notificationStore!.changeMode('edit');
    };

    renderNotification = (notification: Notification) => {
        return (
            <List.Item>
                <NotificationCard notification={notification} kind="preview" editable={false} />
            </List.Item>
        );
    };

    renderAddNotificationButton = () => {
        const { notificationStore } = this.props;
        const ejercicioActual = new Date();
        const visible =
            notificationStore!.ejercicio.toString() === ejercicioActual.getFullYear().toString();
        return visible ? (
            <>
                <List.Item>
                    <Button
                        type="dashed"
                        icon="plus"
                        onClick={this.onClick}
                        style={{ height: '100px', whiteSpace: 'normal' }}
                        block={true}
                    >
                        Añadir una nueva notificación
                    </Button>
                </List.Item>
            </>
        ) : null;
    };

    crearSelectAnios = () => {
        const { notificationStore } = this.props;
        const anios: string[] = [];
        const fecha = new Date();
        for (let i = fecha.getFullYear(); i >= 2018; i--) {
            anios.push(i.toString());
        }
        return (
            <Select
                defaultValue={fecha.getFullYear()}
                style={{ width: '100%' }}
                onChange={this.changeSelectAnios}
                loading={notificationStore!.isFetching}
            >
                {anios.map(value => (
                    <Select.Option key={value}>{value}</Select.Option>
                ))}
            </Select>
        );
    };

    changeSelectAnios = async (value: number) => {
        const { notificationStore, userStore } = this.props;
        notificationStore!.ejercicio = value;
        await notificationStore!.getNotifications(userStore!.rol);
        this.renderAddNotificationButton();
    };

    render() {
        const { notificationStore } = this.props;
        const { notificationCardList } = notificationStore!;
        const TabPane = Tabs.TabPane;

        return (
            <Container>
                <Row>
                    <Col span={8}>
                        {/* <List
                            dataSource={notificationCardList.filter(n => n.id === 0)}
                            renderItem={this.renderAddNotificationButton}
                        /> */}
                        {this.renderAddNotificationButton()}
                    </Col>
                </Row>
                <Row style={{ paddingTop: '20px' }}>
                    <Col span={12}>{this.crearSelectAnios()}</Col>
                </Row>
                <Row style={{ paddingTop: '20px' }}>
                    <Tabs defaultActiveKey="1">
                        <TabPane tab="Prioridad Alta" key="1" >
                            <List
                                grid={{ gutter: 16, xs: 1, sm: 2, md: 4, lg: 4 }}
                                dataSource={toJS(
                                    notificationCardList.filter(
                                        n => n.importancia === Importancia.Alto && n.id !== 0
                                    )
                                )}
                                renderItem={this.renderNotification}
                            />
                        </TabPane>
                        <TabPane tab="Prioridad Media" key="2">
                            <List
                                grid={{ gutter: 16, xs: 1, sm: 2, md: 4, lg: 4 }}
                                dataSource={toJS(
                                    notificationCardList.filter(
                                        n => n.importancia === Importancia.Medio && n.id !== 0
                                    )
                                )}
                                renderItem={this.renderNotification}
                            />
                        </TabPane>
                        <TabPane tab="Prioridad Baja" key="3">
                            <List
                                grid={{ gutter: 16, xs: 1, sm: 2, md: 4, lg: 4 }}
                                dataSource={toJS(
                                    notificationCardList.filter(
                                        n => n.importancia === Importancia.Bajo && n.id !== 0
                                    )
                                )}
                                renderItem={this.renderNotification}
                            />
                        </TabPane>
                    </Tabs>
                    <NotificationModal />
                </Row>
            </Container>
        );
    }
}

export const Notificaciones = withRouter(NotificacionesInner);
